<template>
  <div class="relative w-full" tabindex="0" @blur="blured">
    <div
      class="flex w-full cursor-pointer items-center justify-end"
      @click="() => (menuOpen = !menuOpen)"
    >
      <p class="text-left text-sm text-grey-4">
        <span>
          {{ $t(data + '.title') }}
        </span>
        <span v-if="selectedOption" class="ml-1 text-grey-2">{{
          $tm(data + '.options.' + selectedOption)
        }}</span>
      </p>
      <img
        src="@/assets/svg/arrows/right_grey_arrow_dark.svg"
        alt="down"
        :class="['ml-1 transform', menuOpen ? '-rotate-90' : 'rotate-90']"
      />
    </div>
    <!-- Desktop menu -->
    <div
      v-if="menuOpen"
      class="absolute right-0 hidden w-4/5 rounded-2xl bg-white shadow-2xl lg:block"
    >
      <GeneralInput
        v-model:data="selectedOption"
        noLines
        type="radio"
        name="sort"
        noMargin
        :options="$tm(data + '.options')"
        @click="sort"
        @mouseover="() => (overOptions = true)"
        @mouseleave="() => (overOptions = false)"
      />
    </div>
    <!-- Mobile menu -->
    <Drawer
      v-if="menuOpen"
      minHeight="h-max"
      :grey="false"
      class="lg:hidden"
      @close="() => (menuOpen = !menuOpen)"
    >
      <template v-slot:content>
        <p class="mb-4 text-left font-bold text-grey-2">{{ $t(data + '.title') }}</p>
        <GeneralInput
          v-model:data="selectedOption"
          noLines
          noBoxes
          type="radio"
          name="sort"
          separatedRadio
          bgColor="bg-grey-ghost"
          noMargin
          :options="$tm(data + '.options')"
          @click="sort"
          @mouseover="() => (overOptions = true)"
          @mouseleave="() => (overOptions = false)"
        />
      </template>
    </Drawer>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import GeneralInput from '@/components/general/Input.vue'
import Drawer from '@/components/general/Drawer.vue'
export default {
  components: {
    GeneralInput,
    Drawer,
  },
  props: {
    data: {
      type: String,
      default: '',
    },
    default: {
      type: String,
      default: '',
    },
  },
  emits: ['sort'],

  setup(props, { emit }) {
    const menuOpen = ref(false)
    const selectedOption = ref(props.default != '' ? props.default : null)
    const overOptions = ref(false)

    const sort = () => {
      menuOpen.value = false
      emit('sort', selectedOption.value)
    }

    const blured = () => {
      if (!overOptions.value) menuOpen.value = false
    }

    watch(
      () => props.default,
      () => {
        selectedOption.value = props.default
      }
    )

    return {
      menuOpen,
      selectedOption,
      sort,
      blured,
      overOptions,
    }
  },
}
</script>
